import { cn } from '@/lib/utils';

/**
 * The mark on its own, or the full horizontal lockup.
 *
 * One component for both, so no screen reaches for an asset path directly —
 * which is what keeps replacing the artwork a one-folder job. The files are
 * the customer app's, keyed out to transparency and cropped tight, so `size`
 * here means the artwork's height rather than mostly padding.
 *
 * The wordmark is near-black and would vanish on the dark ground, so there is
 * a second lockup with the type recoloured; the cross keeps its greens in
 * both, because they read on either.
 */

const MARK = '/brand/mark.png';
const LOCKUP = '/brand/lockup.png';
const LOCKUP_DARK = '/brand/lockup-dark.png';

export function BrandMark({ className, size = 32 }: { className?: string; size?: number }) {
  return (
    <img
      src={MARK}
      alt=""
      aria-hidden="true"
      width={314}
      height={316}
      className={cn('w-auto', className)}
      style={{ height: size }}
    />
  );
}

export function BrandLockup({ className, size = 28 }: { className?: string; size?: number }) {
  return (
    // The name is always set in text beside or below it, or is the link's own
    // accessible name, so announcing the artwork too would say the brand twice.
    <span className={cn('inline-flex shrink-0 items-center', className)} aria-hidden="true">
      <img
        src={LOCKUP}
        alt=""
        width={1056}
        height={327}
        className="w-auto dark:hidden"
        style={{ height: size }}
      />
      <img
        src={LOCKUP_DARK}
        alt=""
        width={1056}
        height={327}
        className="hidden w-auto dark:block"
        style={{ height: size }}
      />
    </span>
  );
}
